import { APIResult } from '@shared/Frontend/utils/apiResult'
import { PictureAPIResponse, PictureWithFlags } from './monadsTest.state'

export const getPictures = async (): Promise<PictureAPIResponse> => {
  const res = await fetch('/api/v1/monads/pictures')
  if (!res.ok) {
    const result: string = await res.json()
    return APIResult.Default.Error(res.status, result)
  }
  const deserializedResult: PictureWithFlags[] = await res.json()
  return APIResult.Default.Result(deserializedResult)
}
